/**
 * TrialWall — plan 17: trial guest 3 hari habis.
 *
 * Non-dismissible (tidak ada onClose di backdrop): satu-satunya jalan
 * lanjut adalah login Google GRATIS. Copy bersifat positif — fokus ke
 * "simpan progress", bukan "batas habis".
 *
 * Dibangun di atas RN Modal (pola sama dengan SegeraHadirModal).
 */

import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import { useRouter } from 'expo-router';

import { Brand, Radii, Spacing } from '@/constants/theme';
import { GUEST_TRIAL_DAYS } from '@funpaper/shared';

interface TrialWallProps {
  visible: boolean;
}

export function TrialWall({ visible }: TrialWallProps) {
  const router = useRouter();
  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={styles.backdrop}>
        <View style={styles.card}>
          <Text style={styles.emoji}>🌱</Text>
          <Text style={styles.title}>Masa Coba {GUEST_TRIAL_DAYS} Hari Selesai</Text>
          <Text style={styles.body}>
            Masuk dengan Google — gratis — untuk lanjut mendapat worksheet
            harian tanpa batas dan menyimpan semua progress si kecil.
          </Text>
          <Pressable
            onPress={() => router.replace('/login' as never)}
            style={({ pressed }) => [styles.cta, pressed && styles.ctaPressed]}
            accessibilityRole="button"
            accessibilityLabel="Masuk dengan Google"
          >
            <Text style={styles.ctaText}>Masuk dengan Google</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: Spacing.four,
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: Radii.medium,
    padding: Spacing.four,
    width: '100%',
    maxWidth: 360,
    alignItems: 'center',
    gap: Spacing.two,
  },
  emoji: {
    fontSize: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1A0B5C',
    textAlign: 'center',
  },
  body: {
    fontSize: 14,
    lineHeight: 20,
    color: '#4b5563',
    textAlign: 'center',
  },
  cta: {
    alignSelf: 'stretch',
    marginTop: Spacing.two,
    backgroundColor: Brand.primary,
    paddingVertical: 12,
    borderRadius: Radii.small,
    alignItems: 'center',
  },
  ctaText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '700',
  },
  ctaPressed: {
    opacity: 0.75,
  },
});
